/**
 * NosAKBadgeStore.js
 * Module-level badge store — written by NOSAKContext, read by NosAKSidebar.
 * Allows sidebar (outside NOSAKProvider) to show live badges.
 */
let _badges = { financeReady: 0, evidenceGaps: 0, highRisks: 0, boardAlerts: 0 };
let _listeners = [];

export const setBadges = (b) => {
  _badges = { ..._badges, ...b };
  _listeners.forEach(fn => fn(_badges));
};

export const getBadges = () => _badges;

export const subscribeBadges = (fn) => {
  _listeners.push(fn);
  return () => { _listeners = _listeners.filter(f => f !== fn); };
};
